import type { ICellValue } from '../types'

import z from 'zod'

import { BasicValueType } from '../types'
import { Field } from './field'

export class NotSupportField extends Field {
	static readonly propertySchema = z.null()

	get basicValueType() {
		return BasicValueType.String
	}

	get apiMetaProperty() {
		return null
	}

	get openValueSchema() {
		return z.string().nullable()
	}

	acceptFilterOperators = []

	static defaultProperty() {
		return null
	}

	validateProperty() {
		return NotSupportField.propertySchema.safeParse(this.field.property)
	}

	validateCellValue() {
		return this.validateProperty()
	}

	validateOpenWriteValue() {
		return this.validateProperty()
	}

	override recordEditable() {
		return false
	}

	validate(_value: any): false {
		return false
	}

	cellValueToString(_cellValue: ICellValue): null {
		return null
	}

	cellValueToApiStandardValue(_cellValue: ICellValue): null {
		return null
	}

	cellValueToApiStringValue(_cellValue: ICellValue) {
		return null
	}
	cellValueToOpenValue(_cellValue: ICellValue): null {
		return null
	}

	openWriteValueToCellValue(_openWriteValue: string): null {
		return null
	}
}
